// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CategoriesController from "./categories_controller"
application.register("categories", CategoriesController)

import FeedbackController from "./feedback_controller"
application.register("feedback", FeedbackController)

import IdeasController from "./ideas_controller"
application.register("ideas", IdeasController)

import RssFeedController from "./rss_feed_controller"
application.register("rss-feed", RssFeedController)
